msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-16 14:52+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: sv\n"
"Project-Id-Version: 69ffe877770b8fde5aa44a8b4a76deba\n"
"Report-Msgid-Bugs-To: \n"
"Last-Translator: \n"
"Language-Team: Swedish\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: 69ffe877770b8fde5aa44a8b4a76deba\n"
"X-Crowdin-Project-ID: 550\n"
"X-Crowdin-Language: sv\n"
"X-Crowdin-File-ID: 25212\n"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:32
#: src/components/Ad/lib/formatDistance.ts:49
msgid "distance.with-unit"
msgstr "{distance} km"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:13
msgid "distance.in-meters"
msgstr "{distance} meter"

#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:24
#: src/components/Ad/lib/formatDistance.ts:39
msgid "distance.mobility-unit"
msgstr "{distance} mil"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:61
msgid "explore.filter.range.label"
msgstr "{filterName} räckvidd"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:82
msgid "filters.range.maximum.label"
msgstr "{filterName}, max"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:68
msgid "filters.range.minimum.label"
msgstr "{filterName}, min"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:626
#: src/islands/search/SearchBar.tsx:622
msgid "explore.searchInput.filters.range.both"
msgstr "{min}–{max}"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:7
msgid "distance.less-than-100m"
msgstr "100 meter eller mindre"

#. js-lingui-explicit-id
#: src/components/Ad/AdImageWrapper.tsx:22
msgid "search.ad.recommerce.image-alt"
msgstr "Annonsbild"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:120
msgid "explore.filters.all"
msgstr "Alla"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:134
#: src/islands/search/FiltersModal.tsx:141
msgid "explore.searchInput.filters.title"
msgstr "Alla filter"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:853
msgid "explore.searchInput.filters.apply"
msgstr "Använd"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:24
#: src/islands/header/Header.tsx:33
#: src/islands/search/StickySearchBar.tsx:76
#: src/islands/search/StickySearchBar.tsx:85
msgid "explore.back.button"
msgstr "Tillbaka"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:127
msgid "explore.suggestions.title"
msgstr "Baserat på din sökning"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:135
msgid "explore.results.title"
msgstr "Baserat på din sökning"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:54
msgid "explore.header.badge"
msgstr "Beta"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:866
msgid "explore.searchInput.filters.clear.single"
msgstr "Rensa"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:841
msgid "explore.searchInput.filters.clear"
msgstr "Rensa alla"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:763
#: src/islands/search/SearchBar.tsx:778
msgid "explore.searchInput.clear"
msgstr "Rensa text"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:176
#: src/islands/search/FiltersModal.tsx:181
msgid "explore.searchInput.filters.close"
msgstr "Stäng filter"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:52
msgid "explore.results.errorstate.network.heading"
msgstr "Fel med anslutningen"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:74
msgid "explore.suggestions.title.discover.more"
msgstr "Upptäck mer"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:48
msgid "explore.header.title"
msgstr "Utforska"

#. js-lingui-explicit-id
#: src/server/server.ts:170
msgid "page.title"
msgstr "Utforska – Hitta ditt nästa fynd på Blocket med hjälp av AI"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:58
msgid "explore.sorting.info.body-try-it-two"
msgstr "Utforska analyserar all information i en annons, inklusive bilderna när den letar efter träffar. Blockets vanliga sökfunktion söker bara igenom annonstexterna."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:55
msgid "explore.sorting.info.title-two"
msgstr "Utforska analyserar text och bilder"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:26
msgid "explore.results.errorstate.server.message"
msgstr "Utforska fungerar inte just nu, men vi jobbar på det. Försök igen lite senare!"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:36
msgid "explore.sorting.info.body-one"
msgstr "Utforska använder AI för att förstå vad du letar efter. Till skillnad från Blockets vanliga sökfunktion, som bara visar träffar baserat på dina sökord, använder Utforska mer än bara nyckelord för att hitta annonser som är relevanta för dig."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:57
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:60
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:86
msgid "explore.filter.fallback"
msgstr "Filter"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:137
msgid "explore.searchInput.filters.back"
msgstr "Filter"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:824
msgid "explore.searchInput.filters"
msgstr "Filter"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:22
msgid "explore.sorting.info.trigger"
msgstr "Ta reda på hur det fungerar"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:61
msgid "explore.prompt.subtitle"
msgstr "Hitta ditt nästa fynd på Blocket med hjälp av AI"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:638
#: src/islands/search/SearchBar.tsx:628
#: src/islands/search/SearchBar.tsx:687
msgid "explore.searchInput.filters.range.min"
msgstr "Från {value}"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:70
msgid "explore.results.feedback.followup.button"
msgstr "Dela dina synpunkter"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:79
msgid "explore.results.errorstate.goback.label"
msgstr "Gå tillbaka till sökning på Blocket"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:143
msgid "explore.results.count.hits"
msgstr "träffar"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:29
msgid "explore.sorting.title"
msgstr "Så här fungerar Utforska"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:98
#: src/islands/suggestions/Suggestions.tsx:165
msgid "explore.suggestions.buttons.loading"
msgstr "Laddar förslag"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:56
msgid "explore.suggestions.placeholder"
msgstr "Laddar …"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:111
msgid "explore.searchInput.filters.range.max.label"
msgstr "Maxvärde"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:107
msgid "explore.searchInput.filters.range.min.label"
msgstr "Minvärde"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:102
msgid "explore.results.feedback.negative.label"
msgstr "Negativ återkoppling"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:707
msgid "explore.searchInput.filters.empty"
msgstr "Inga filter tillgängliga"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:30
msgid "explore.results.zero-results.alt-text"
msgstr "Inga träffar"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:36
msgid "explore.results.zero-results.heading"
msgstr "Inga träffar"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:37
msgid "explore.results.errorstate.client.heading"
msgstr "Åh nej!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:92
msgid "explore.results.feedback.positive.label"
msgstr "Positiv återkoppling"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:60
msgid "explore.filter.price.label"
msgstr "Prisintervall"

#. js-lingui-explicit-id
#: src/server/server.ts:171
msgid "page.description"
msgstr "Torget-sida för att möjliggöra semantisk sökning"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:742
#: src/islands/search/SearchBar.tsx:791
msgid "explore.searchInput.ariaLabel"
msgstr "Sök"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:69
msgid "explore.sorting.info.body-try-it-two-rest"
msgstr "Sök efter ”kläder till en sommarfest med företaget” så föreslår Utforska kläder som passar tillfället."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:33
msgid "explore.sorting.info.title-one"
msgstr "Sökträffar baserade på avsikt"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:855
msgid "explore.searchInput.calloutText"
msgstr "Sök med en mening"

#. js-lingui-explicit-id
#: src/components/Ad/AdLocation.tsx:20
msgid "search.ad.bap.sold"
msgstr "Såld"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:41
msgid "explore.results.errorstate.client.message"
msgstr "Något gick fel och vi kunde inte ladda några varor. Försök igen!"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:22
msgid "explore.results.errorstate.server.heading"
msgstr "Äsch!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:26
msgid "explore.results.feedback.followup.negative"
msgstr "Tack! Vill du berätta mer om vad du inte gillade?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:21
msgid "explore.results.feedback.followup.positive"
msgstr "Tack! Vill du berätta mer om vad du gillade?"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:98
msgid "explore.filter.range.invalid"
msgstr "Maxvärdet kan inte vara lägre än minvärdet."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:795
msgid "explore.searchInput.helpText"
msgstr "Tips! Använd beskrivande meningar"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:136
#: src/islands/results/ErrorState.tsx:142
msgid "explore.results.errorstate.retry.label"
msgstr "Försök igen"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:45
#: src/islands/results/SortingInfo.tsx:67
msgid "explore.sorting.info.try-it"
msgstr "Testa själv!"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:131
msgid "explore.suggestions.title.discover"
msgstr "Testa att söka efter"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:43
msgid "explore.results.zero-results.message"
msgstr "Prova att formulera sökningen lite annorlunda eller ändra dina filter för att hitta vad du letar efter."

#. js-lingui-explicit-id
#: src/components/Ad/AdImageOptions.tsx:15
msgid "search.ad.fallback-image-alt"
msgstr "Två berg och ett moln"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:47
msgid "explore.sorting.info.body-try-it-one-rest"
msgstr "Skriv ”retro saker till köket” så föreslår Utforska passande annonser som retroserviser, lampor och dekorationer."

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:82
#: src/islands/suggestions/Suggestions.tsx:149
msgid "explore.suggestions.title.error"
msgstr "Det gick inte att ladda förslag. Försök igen."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:647
#: src/islands/search/SearchBar.tsx:634
#: src/islands/search/SearchBar.tsx:689
msgid "explore.searchInput.filters.range.max"
msgstr "Upp till {value}"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:878
msgid "explore.searchInput.filters.use"
msgstr "Använd"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:110
#: src/islands/results/ErrorState.tsx:116
msgid "explore.results.errorstate.help.center.label"
msgstr "Besök vårt hjälpcenter"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:56
msgid "explore.results.errorstate.network.message"
msgstr "Det gick inte att nå våra servrar. Kontrollera din internetanslutning och försök igen."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:787
msgid "explore.searchInput.placeholder"
msgstr "Vad söker du?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:83
msgid "explore.results.feedback.prompt"
msgstr "Vad tycker du om Utforska?"

